import './index.scss';
import './public-path';
import { getRootElement } from '@packages/react/lib/rootUtils';
import React from 'react';
import { render } from 'react-dom';
import { bootstrap } from './bootstrap';

// noinspection JSIgnoredPromiseFromCall
bootstrap(async () => {
    // In order to prevent initialization of some modules with
    // not configured PlatformService, the App module it's imported
    // in the bootstrap function
    // eslint-disable-next-line
    const { App } = require('./App');
    render(<App />, getRootElement());
});
